/* suite.io — Equipment names from Firestore
   Reads app/equipment_config once, builds ID→name map.
   Hardcoded fallback in case Firestore is unavailable. */

import { dataService } from "./dataService.js";

const FALLBACK = {
  big_rig: "Big Rig", head_rig: "Head Rig", leo: "Artec Leo", leo_b: "Artec Leo",
  spider: "Artec Space Spider II", spider_i: "Artec Space Spider I",
  r5: "Canon R5", r5e: "Canon R5", rtc: "Leica RTC 360",
  drone: "DJI Mavic 3E", flying_fox: "Flying Fox",
  portal: "XGrids PortalCam", nimble: "Scanology NimbleTrack Gen 2",
  mobile: "Big Rig",
};

// Exported for tests that check aliasing against the real catalog shape.
export const EQUIPMENT_FALLBACK = FALLBACK;

let _names = null;

/** Load equipment names from Firestore (called once at app init). */
export async function loadEquipmentNames() {
  try {
    const config = await dataService.kv.getRaw("equipment_config");
    if (config?.equipment?.length) {
      const map = {};
      for (const eq of config.equipment) {
        map[eq.id] = eq.name;
        if (eq.shortName && eq.shortName !== eq.name) map[eq.id + "_short"] = eq.shortName;
      }
      // Aliases for virtual/legacy IDs
      map.leo_b = map.leo || FALLBACK.leo;
      map.r5e = map.r5 || FALLBACK.r5;
      map.mobile = map.big_rig || FALLBACK.big_rig;
      _names = map;
    }
  } catch (e) {
    console.error("loadEquipmentNames:", e);
  }
  if (!_names) _names = { ...FALLBACK };
}

/** Get the ID→name map (falls back to hardcoded if not yet loaded). */
export function getEqNames() {
  return _names || FALLBACK;
}

/** Resolve an equipment object or string to a display name. */
export function eqLabel(eq) {
  if (!eq) return "Equipment";
  if (typeof eq === "string") return eq;
  return eq.name || getEqNames()[eq.id] || eq.id || "Equipment";
}
